import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=06fa5a3b&scoped=true&lang=pug"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=06fa5a3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fa5a3b",
  null
  
)

export default component.exports